import { css } from '@emotion/core'

export const getDynamicSizeColumnStyles = () =>
  // `!important` is required to make sure that inline styles from `react-table` are overridden correctly.
  css`
    flex-basis: unset !important;
    flex-shrink: 1 !important;
  `
